import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * Same idea as RxJS 7 {@link firstValueFrom}; Angular 10 stays on RxJS 6.
 *
 * @returns The first emitted value, or `undefined` if the observable completed without emitting.
 */
export function firstValueFromRx6<T>(source: Observable<T>): Promise<T | undefined> {
  return source.pipe(take(1)).toPromise();
}
